import React, { useEffect, useState } from 'react';
import {
  TextInput,
  Button,
  Box,
  Group,
} from '@mantine/core';
import { useForm } from '@mantine/form';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import toast from 'react-hot-toast';

import ApiLinks from '../../Navlinks/ApiLinks';
import LoaderOverlay from '../../Utilities/LoadingOverLay';

function AddState() {
  const location = useLocation();
  const id = location.state?.id;
  const user = useSelector((state) => state.auth.user);
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  const form = useForm({
    initialValues: {
      stateid: '',
      compcode: user?.compcode || '',
      statename: '',
    },
  });

  useEffect(() => {
    
    if (id) {
      setLoading(true);
      axios
        .get(
          `${process.env.REACT_APP_API_URL}/${ApiLinks.State_GetById}/${id}/${user.compcode}`
        )
        .then((response) => {
          if (response.data.status && response.data.data.length > 0) {
            const data = response.data.data[0];
            form.setValues({
              stateid: data.stateid,
              compcode: data.compcode,
              statename: data.statename,
            });
          }
        })
        .catch((err) => {
          console.error('Error loading category:', err);
        })
        .finally(() => setLoading(false));
    }
  }, [id, user.compcode]);

  const handleSubmit = (values) => {
    if (!values.statename.trim()) {
      toast.error('Category name is required.');
      return;
    }

    setLoading(true);

    // Build JSON payload
   
    const request = id && id !== 0
      ? axios.put(`${process.env.REACT_APP_API_URL}/${ApiLinks.State_Update}`, values, {
          headers: {
            'Content-Type': 'application/json',
          },
        })
      : axios.post(`${process.env.REACT_APP_API_URL}/${ApiLinks.State_Save}`, values, {
          headers: {
            'Content-Type': 'application/json',
          },
        });

    request.then((res) => {
      if (res.data.status) {
        Swal.fire({
          title: id ? 'Updated!' : 'Created!',
          text: `State ${id ? 'updated' : 'created'} successfully.`,
          icon: 'success',
          confirmButtonText: 'OK',
        }).then(() => {
          navigate('/dashboard/state');
        });
      } else {
        Swal.fire('Error!', res.data.message || 'Failed to save category.', 'error');
      }
    })
      .catch(() => {
        Swal.fire('Error!', 'An error occurred while saving.', 'error');
      })
      .finally(() => setLoading(false));
  };

  if (loading) return <LoaderOverlay />;

  return (
    <Box maw={500} mx="auto" sx={(theme) => ({
      backgroundColor: 'white',
      padding: theme.spacing.xl,
      borderRadius: theme.radius.md,
      boxShadow: theme.shadows.md,
    })}>
      <Group position="apart" mb="md">
        <h2>{id ? 'Edit State' : 'Create State'}</h2>
        <Button onClick={() => navigate('/dashboard/state')}>Back</Button>
      </Group>

      <form onSubmit={form.onSubmit(handleSubmit)}>
        <TextInput
          label="Name"
          placeholder="Enter name"
          {...form.getInputProps('statename')}
        />

        <Button type="submit" mt="lg" fullWidth>
          {id ? 'Update' : 'Create'}
        </Button>
      </form>
    </Box>
  );
}

export default AddState;
